import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import Link from 'next/link';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';
import styles from './Rss.module.scss';

const Rss: FC<IWidgetsSideBar> = ({ todayWidget, popularBooksWidget }) => {
  //seo block
  const SEO_TITLE = 'Новинки книг в формате RSS :: Электронная библиотека : лента новых книг';
  const SEO_DESCRIPTION = 'RSS лента новинок книг в электронной библиотеке :: BookZ.ru';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref="/rss" isSmallPage breadcrumbs={<Breadcrumbs firstPageName="Вопросы по скачиванию/чтению книг" />} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget}>
      <h4 className="pageTitle">Наши RSS-ленты</h4>
      <div className="pageBlock">
        В нашей библиотеке доступна лента новинок. Самый главный новостной поток сайта содержит сведения о всех новых поступлениях:
        <br />
        <div>
          <Link prefetch={false} target="_blank" href="/new_books.xml">
            <img width="34" height="15" className={styles.rssIcon} src="/icons/rss-icon.png" alt="rss-icon" />
          </Link>{' '}
          <Link prefetch={false} className="pageLink" target="_blank" href="/new_books.xml">
            Все новые книги нашей библиотеки.
          </Link>
        </div>
      </div>

      <h4 className="pageTitle">Общие вопросы</h4>
      <div className="pageBlock">
        RSS (Really Simple Syndication) - технология, предназначенная для создания лент новостей, анонсов статей, изменений на сайтах и т.п. Благодаря данной технологии, вместо того, чтобы периодически заходить на наш сайт в поисках новых книг, Вы
        можете воспользоваться специальными программами (агрегаторы) или онлайн-сервисами, которые будут Вам мгновенно сообщать о появлении новых книг в нашей библиотеке.
      </div>

      <h4 className="pageTitle">Программы-агрегаторы для ОС Windows </h4>
      <div className="pageBlock">
        Браузеры со встроенными возможностями чтения RSS, например, ряд современных браузеров:{' '}
        <a className="pageLink" href="https://yandex.ru/soft/browsers/" target="_blanc">
          browsers.yandex.ru
        </a>
        .
      </div>

      <h4 className="pageTitle">Разрешение проблем</h4>
      <div className="pageBlock">Если при скачивании архива книги возникают проблемы (выдается ошибка "документ не найден" или требуется ввести логин и пароль), нажмите кнопку "обновить" ("refresh") в Вашем браузере.</div>

      <div>
        Установив подобный браузер, Вам будет достаточно кликнуть на значке{' '}
        <Link prefetch={false} target="_blank" href="/new_books.xml">
          <img width="34" height="15" className={styles.rssIcon} src="/icons/rss-icon.png" alt="rss-icon" />
        </Link>
        , чтобы подписаться на RSS-новости.
      </div>
    </Layout>
  );
};
export default Rss;
